import React, {Component} from 'react'

export default class CredentialsInput extends Component {

    inputChanged = (event) => {
        const text = event.target.value;
        this.props.onChanged(text)
    };

    render() {
        return (
            <div className="form-group">
                <input
                    id={this.props.id}
                    type={this.props.type}
                    onChange={this.inputChanged}
                    className="form-control bottom"
                    placeholder={this.props.placeholder}
                    required/>
            </div>
        )
    }
}

CredentialsInput.propTypes = {
    id: React.PropTypes.string.isRequired,
    type: React.PropTypes.string.isRequired,
    placeholder: React.PropTypes.string.isRequired,
    onChanged: React.PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/auth/CredentialsInput.js